import { render, staticRenderFns } from "./setting-testdoc.vue?vue&type=template&id=19d70b46&scoped=true"
import script from "./setting-testdoc.vue?vue&type=script&lang=js"
export * from "./setting-testdoc.vue?vue&type=script&lang=js"
import style0 from "./setting-testdoc.vue?vue&type=style&index=0&id=19d70b46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d70b46",
  null
  
)

export default component.exports